
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("1G4lu"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("igbDj"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("eMCOX"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("1tA3q"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("bHl4H"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("LVCoo"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("kIJem"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("jLAUg"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("hSmxL"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("bLUyo"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("chnoM"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("7uH8A"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("1G4lu", function(module, exports) {

let $138d15a7356c67c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $138d15a7356c67c1$var$load("2YffH"),
    $138d15a7356c67c1$var$load("1o23t"),
    $138d15a7356c67c1$var$load("lqFMg"),
    $138d15a7356c67c1$var$load("duC9l"),
    $138d15a7356c67c1$var$load("ci4aH"),
    $138d15a7356c67c1$var$load("l1nJ9"),
    $138d15a7356c67c1$var$load("iQ0Jm"),
    $138d15a7356c67c1$var$load("eBRUf"),
    $138d15a7356c67c1$var$load("9Vh0G"),
    $138d15a7356c67c1$var$load("hBIgN"),
    $138d15a7356c67c1$var$load("h4Nf7"),
    $138d15a7356c67c1$var$load("7f9Fz"),
    $138d15a7356c67c1$var$load("8YSo7"),
    $138d15a7356c67c1$var$load("eYWAR"),
    $138d15a7356c67c1$var$load("8z2kq"),
    $138d15a7356c67c1$var$load("g9CVe"),
    $138d15a7356c67c1$var$load("djHM5"),
    $138d15a7356c67c1$var$load("eJQji"),
    $138d15a7356c67c1$var$load("6wr18"),
    $138d15a7356c67c1$var$load("kjZZD"),
    $138d15a7356c67c1$var$load("3JSgG"),
    $138d15a7356c67c1$var$load("dRpV3"),
    $138d15a7356c67c1$var$load("ffEVr"),
    $138d15a7356c67c1$var$load("dTsOE"),
    $138d15a7356c67c1$var$load("jYUNl"),
    $138d15a7356c67c1$var$load("foy8I"),
    $138d15a7356c67c1$var$load("jY21r"),
    $138d15a7356c67c1$var$load("2vAWg"),
    $138d15a7356c67c1$var$load("7cABH"),
    $138d15a7356c67c1$var$load("9jjvO"),
    $138d15a7356c67c1$var$load("i8eeg"),
    $138d15a7356c67c1$var$load("iFdoJ"),
    $138d15a7356c67c1$var$load("2uVTT"),
    $138d15a7356c67c1$var$load("hhss7"),
    $138d15a7356c67c1$var$load("Wowvf"),
    $138d15a7356c67c1$var$load("4Nzvy"),
    $138d15a7356c67c1$var$load("hJpvQ"),
    $138d15a7356c67c1$var$load("bIPPg"),
    $138d15a7356c67c1$var$load("lnKog"),
    $138d15a7356c67c1$var$load("h3ABO"),
    $138d15a7356c67c1$var$load("kC80R"),
    $138d15a7356c67c1$var$load("7EorR"),
    $138d15a7356c67c1$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("igbDj", function(module, exports) {

let $d4b2beb258b0fe96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d4b2beb258b0fe96$var$load("2YffH"),
    $d4b2beb258b0fe96$var$load("1o23t"),
    $d4b2beb258b0fe96$var$load("lqFMg"),
    $d4b2beb258b0fe96$var$load("duC9l"),
    $d4b2beb258b0fe96$var$load("ci4aH"),
    $d4b2beb258b0fe96$var$load("l1nJ9"),
    $d4b2beb258b0fe96$var$load("iQ0Jm"),
    $d4b2beb258b0fe96$var$load("eBRUf"),
    $d4b2beb258b0fe96$var$load("9Vh0G"),
    $d4b2beb258b0fe96$var$load("hBIgN"),
    $d4b2beb258b0fe96$var$load("h4Nf7"),
    $d4b2beb258b0fe96$var$load("7f9Fz"),
    $d4b2beb258b0fe96$var$load("8YSo7"),
    $d4b2beb258b0fe96$var$load("eYWAR"),
    $d4b2beb258b0fe96$var$load("8z2kq"),
    $d4b2beb258b0fe96$var$load("g9CVe"),
    $d4b2beb258b0fe96$var$load("djHM5"),
    $d4b2beb258b0fe96$var$load("eJQji"),
    $d4b2beb258b0fe96$var$load("6wr18"),
    $d4b2beb258b0fe96$var$load("kjZZD"),
    $d4b2beb258b0fe96$var$load("3JSgG"),
    $d4b2beb258b0fe96$var$load("dRpV3"),
    $d4b2beb258b0fe96$var$load("ffEVr"),
    $d4b2beb258b0fe96$var$load("dTsOE"),
    $d4b2beb258b0fe96$var$load("jYUNl"),
    $d4b2beb258b0fe96$var$load("foy8I"),
    $d4b2beb258b0fe96$var$load("jY21r"),
    $d4b2beb258b0fe96$var$load("2vAWg"),
    $d4b2beb258b0fe96$var$load("7cABH"),
    $d4b2beb258b0fe96$var$load("9jjvO"),
    $d4b2beb258b0fe96$var$load("i8eeg"),
    $d4b2beb258b0fe96$var$load("iFdoJ"),
    $d4b2beb258b0fe96$var$load("2uVTT"),
    $d4b2beb258b0fe96$var$load("hhss7"),
    $d4b2beb258b0fe96$var$load("Wowvf"),
    $d4b2beb258b0fe96$var$load("4Nzvy"),
    $d4b2beb258b0fe96$var$load("hJpvQ"),
    $d4b2beb258b0fe96$var$load("bIPPg"),
    $d4b2beb258b0fe96$var$load("lnKog"),
    $d4b2beb258b0fe96$var$load("h3ABO"),
    $d4b2beb258b0fe96$var$load("kC80R"),
    $d4b2beb258b0fe96$var$load("7EorR"),
    $d4b2beb258b0fe96$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("eMCOX", function(module, exports) {

let $ac33a96c5237a629$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac33a96c5237a629$var$load("2YffH"),
    $ac33a96c5237a629$var$load("1o23t"),
    $ac33a96c5237a629$var$load("lqFMg"),
    $ac33a96c5237a629$var$load("duC9l"),
    $ac33a96c5237a629$var$load("ci4aH"),
    $ac33a96c5237a629$var$load("l1nJ9"),
    $ac33a96c5237a629$var$load("iQ0Jm"),
    $ac33a96c5237a629$var$load("eBRUf"),
    $ac33a96c5237a629$var$load("9Vh0G"),
    $ac33a96c5237a629$var$load("hBIgN"),
    $ac33a96c5237a629$var$load("h4Nf7"),
    $ac33a96c5237a629$var$load("7f9Fz"),
    $ac33a96c5237a629$var$load("8YSo7"),
    $ac33a96c5237a629$var$load("eYWAR"),
    $ac33a96c5237a629$var$load("8z2kq"),
    $ac33a96c5237a629$var$load("g9CVe"),
    $ac33a96c5237a629$var$load("djHM5"),
    $ac33a96c5237a629$var$load("eJQji"),
    $ac33a96c5237a629$var$load("6wr18"),
    $ac33a96c5237a629$var$load("kjZZD"),
    $ac33a96c5237a629$var$load("3JSgG"),
    $ac33a96c5237a629$var$load("dRpV3"),
    $ac33a96c5237a629$var$load("ffEVr"),
    $ac33a96c5237a629$var$load("dTsOE"),
    $ac33a96c5237a629$var$load("jYUNl"),
    $ac33a96c5237a629$var$load("foy8I"),
    $ac33a96c5237a629$var$load("jY21r"),
    $ac33a96c5237a629$var$load("2vAWg"),
    $ac33a96c5237a629$var$load("7cABH"),
    $ac33a96c5237a629$var$load("9jjvO"),
    $ac33a96c5237a629$var$load("i8eeg"),
    $ac33a96c5237a629$var$load("iFdoJ"),
    $ac33a96c5237a629$var$load("2uVTT"),
    $ac33a96c5237a629$var$load("hhss7"),
    $ac33a96c5237a629$var$load("Wowvf"),
    $ac33a96c5237a629$var$load("4Nzvy"),
    $ac33a96c5237a629$var$load("hJpvQ"),
    $ac33a96c5237a629$var$load("bIPPg"),
    $ac33a96c5237a629$var$load("lnKog"),
    $ac33a96c5237a629$var$load("h3ABO"),
    $ac33a96c5237a629$var$load("kC80R"),
    $ac33a96c5237a629$var$load("7EorR"),
    $ac33a96c5237a629$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("1tA3q", function(module, exports) {

let $1134777ab8a41e32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1134777ab8a41e32$var$load("eYWAR"),
    $1134777ab8a41e32$var$load("8z2kq"),
    $1134777ab8a41e32$var$load("2YffH"),
    $1134777ab8a41e32$var$load("lqFMg"),
    $1134777ab8a41e32$var$load("duC9l"),
    $1134777ab8a41e32$var$load("ci4aH"),
    $1134777ab8a41e32$var$load("hJpvQ"),
    $1134777ab8a41e32$var$load("l1nJ9"),
    $1134777ab8a41e32$var$load("eBRUf"),
    $1134777ab8a41e32$var$load("9Vh0G"),
    $1134777ab8a41e32$var$load("hBIgN"),
    $1134777ab8a41e32$var$load("h4Nf7"),
    $1134777ab8a41e32$var$load("7f9Fz"),
    $1134777ab8a41e32$var$load("8YSo7"),
    $1134777ab8a41e32$var$load("g9CVe"),
    $1134777ab8a41e32$var$load("djHM5"),
    $1134777ab8a41e32$var$load("eJQji"),
    $1134777ab8a41e32$var$load("6wr18"),
    $1134777ab8a41e32$var$load("kjZZD"),
    $1134777ab8a41e32$var$load("3JSgG"),
    $1134777ab8a41e32$var$load("dRpV3"),
    $1134777ab8a41e32$var$load("ffEVr"),
    $1134777ab8a41e32$var$load("dTsOE"),
    $1134777ab8a41e32$var$load("jYUNl"),
    $1134777ab8a41e32$var$load("foy8I"),
    $1134777ab8a41e32$var$load("jY21r"),
    $1134777ab8a41e32$var$load("2vAWg"),
    $1134777ab8a41e32$var$load("7cABH"),
    $1134777ab8a41e32$var$load("9jjvO"),
    $1134777ab8a41e32$var$load("i8eeg"),
    $1134777ab8a41e32$var$load("iFdoJ"),
    $1134777ab8a41e32$var$load("bIPPg"),
    $1134777ab8a41e32$var$load("2uVTT"),
    $1134777ab8a41e32$var$load("hhss7"),
    $1134777ab8a41e32$var$load("Wowvf"),
    $1134777ab8a41e32$var$load("4Nzvy"),
    $1134777ab8a41e32$var$load("h3ABO"),
    $1134777ab8a41e32$var$load("kC80R"),
    $1134777ab8a41e32$var$load("7EorR"),
    $1134777ab8a41e32$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("bHl4H", function(module, exports) {

let $88440edabf2803ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $88440edabf2803ff$var$load("eYWAR"),
    $88440edabf2803ff$var$load("8z2kq"),
    $88440edabf2803ff$var$load("2YffH"),
    $88440edabf2803ff$var$load("lqFMg"),
    $88440edabf2803ff$var$load("duC9l"),
    $88440edabf2803ff$var$load("ci4aH"),
    $88440edabf2803ff$var$load("hJpvQ"),
    $88440edabf2803ff$var$load("l1nJ9"),
    $88440edabf2803ff$var$load("eBRUf"),
    $88440edabf2803ff$var$load("9Vh0G"),
    $88440edabf2803ff$var$load("hBIgN"),
    $88440edabf2803ff$var$load("h4Nf7"),
    $88440edabf2803ff$var$load("7f9Fz"),
    $88440edabf2803ff$var$load("8YSo7"),
    $88440edabf2803ff$var$load("g9CVe"),
    $88440edabf2803ff$var$load("djHM5"),
    $88440edabf2803ff$var$load("eJQji"),
    $88440edabf2803ff$var$load("6wr18"),
    $88440edabf2803ff$var$load("kjZZD"),
    $88440edabf2803ff$var$load("3JSgG"),
    $88440edabf2803ff$var$load("dRpV3"),
    $88440edabf2803ff$var$load("ffEVr"),
    $88440edabf2803ff$var$load("dTsOE"),
    $88440edabf2803ff$var$load("jYUNl"),
    $88440edabf2803ff$var$load("foy8I"),
    $88440edabf2803ff$var$load("jY21r"),
    $88440edabf2803ff$var$load("2vAWg"),
    $88440edabf2803ff$var$load("7cABH"),
    $88440edabf2803ff$var$load("9jjvO"),
    $88440edabf2803ff$var$load("i8eeg"),
    $88440edabf2803ff$var$load("iFdoJ"),
    $88440edabf2803ff$var$load("bIPPg"),
    $88440edabf2803ff$var$load("2uVTT"),
    $88440edabf2803ff$var$load("hhss7"),
    $88440edabf2803ff$var$load("Wowvf"),
    $88440edabf2803ff$var$load("4Nzvy"),
    $88440edabf2803ff$var$load("h3ABO"),
    $88440edabf2803ff$var$load("kC80R"),
    $88440edabf2803ff$var$load("7EorR"),
    $88440edabf2803ff$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("LVCoo", function(module, exports) {

let $090115ae878c123d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $090115ae878c123d$var$load("eYWAR"),
    $090115ae878c123d$var$load("8z2kq"),
    $090115ae878c123d$var$load("2YffH"),
    $090115ae878c123d$var$load("lqFMg"),
    $090115ae878c123d$var$load("duC9l"),
    $090115ae878c123d$var$load("ci4aH"),
    $090115ae878c123d$var$load("hJpvQ"),
    $090115ae878c123d$var$load("l1nJ9"),
    $090115ae878c123d$var$load("eBRUf"),
    $090115ae878c123d$var$load("9Vh0G"),
    $090115ae878c123d$var$load("hBIgN"),
    $090115ae878c123d$var$load("h4Nf7"),
    $090115ae878c123d$var$load("7f9Fz"),
    $090115ae878c123d$var$load("8YSo7"),
    $090115ae878c123d$var$load("g9CVe"),
    $090115ae878c123d$var$load("djHM5"),
    $090115ae878c123d$var$load("eJQji"),
    $090115ae878c123d$var$load("6wr18"),
    $090115ae878c123d$var$load("kjZZD"),
    $090115ae878c123d$var$load("3JSgG"),
    $090115ae878c123d$var$load("dRpV3"),
    $090115ae878c123d$var$load("ffEVr"),
    $090115ae878c123d$var$load("dTsOE"),
    $090115ae878c123d$var$load("jYUNl"),
    $090115ae878c123d$var$load("foy8I"),
    $090115ae878c123d$var$load("jY21r"),
    $090115ae878c123d$var$load("2vAWg"),
    $090115ae878c123d$var$load("7cABH"),
    $090115ae878c123d$var$load("9jjvO"),
    $090115ae878c123d$var$load("i8eeg"),
    $090115ae878c123d$var$load("iFdoJ"),
    $090115ae878c123d$var$load("bIPPg"),
    $090115ae878c123d$var$load("2uVTT"),
    $090115ae878c123d$var$load("hhss7"),
    $090115ae878c123d$var$load("Wowvf"),
    $090115ae878c123d$var$load("4Nzvy"),
    $090115ae878c123d$var$load("h3ABO"),
    $090115ae878c123d$var$load("kC80R"),
    $090115ae878c123d$var$load("7EorR"),
    $090115ae878c123d$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("kIJem", function(module, exports) {

let $f15b008d2d66f3c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f15b008d2d66f3c5$var$load("eYWAR"),
    $f15b008d2d66f3c5$var$load("8z2kq"),
    $f15b008d2d66f3c5$var$load("2YffH"),
    $f15b008d2d66f3c5$var$load("lqFMg"),
    $f15b008d2d66f3c5$var$load("duC9l"),
    $f15b008d2d66f3c5$var$load("ci4aH"),
    $f15b008d2d66f3c5$var$load("l1nJ9"),
    $f15b008d2d66f3c5$var$load("eBRUf"),
    $f15b008d2d66f3c5$var$load("9Vh0G"),
    $f15b008d2d66f3c5$var$load("hBIgN"),
    $f15b008d2d66f3c5$var$load("h4Nf7"),
    $f15b008d2d66f3c5$var$load("7f9Fz"),
    $f15b008d2d66f3c5$var$load("8YSo7"),
    $f15b008d2d66f3c5$var$load("g9CVe"),
    $f15b008d2d66f3c5$var$load("djHM5"),
    $f15b008d2d66f3c5$var$load("eJQji"),
    $f15b008d2d66f3c5$var$load("6wr18"),
    $f15b008d2d66f3c5$var$load("kjZZD"),
    $f15b008d2d66f3c5$var$load("3JSgG"),
    $f15b008d2d66f3c5$var$load("dRpV3"),
    $f15b008d2d66f3c5$var$load("ffEVr"),
    $f15b008d2d66f3c5$var$load("dTsOE"),
    $f15b008d2d66f3c5$var$load("jYUNl"),
    $f15b008d2d66f3c5$var$load("foy8I"),
    $f15b008d2d66f3c5$var$load("jY21r"),
    $f15b008d2d66f3c5$var$load("2vAWg"),
    $f15b008d2d66f3c5$var$load("7cABH"),
    $f15b008d2d66f3c5$var$load("9jjvO"),
    $f15b008d2d66f3c5$var$load("i8eeg"),
    $f15b008d2d66f3c5$var$load("iFdoJ"),
    $f15b008d2d66f3c5$var$load("2uVTT"),
    $f15b008d2d66f3c5$var$load("hhss7"),
    $f15b008d2d66f3c5$var$load("Wowvf"),
    $f15b008d2d66f3c5$var$load("4Nzvy"),
    $f15b008d2d66f3c5$var$load("hJpvQ"),
    $f15b008d2d66f3c5$var$load("bIPPg"),
    $f15b008d2d66f3c5$var$load("lnKog"),
    $f15b008d2d66f3c5$var$load("h3ABO"),
    $f15b008d2d66f3c5$var$load("kC80R"),
    $f15b008d2d66f3c5$var$load("7EorR"),
    $f15b008d2d66f3c5$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("jLAUg", function(module, exports) {

let $e63f08fcb2ac4df1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e63f08fcb2ac4df1$var$load("2YffH"),
    $e63f08fcb2ac4df1$var$load("lqFMg"),
    $e63f08fcb2ac4df1$var$load("duC9l"),
    $e63f08fcb2ac4df1$var$load("ci4aH"),
    $e63f08fcb2ac4df1$var$load("l1nJ9"),
    $e63f08fcb2ac4df1$var$load("eBRUf"),
    $e63f08fcb2ac4df1$var$load("9Vh0G"),
    $e63f08fcb2ac4df1$var$load("hBIgN"),
    $e63f08fcb2ac4df1$var$load("h4Nf7"),
    $e63f08fcb2ac4df1$var$load("7f9Fz"),
    $e63f08fcb2ac4df1$var$load("8YSo7"),
    $e63f08fcb2ac4df1$var$load("eYWAR"),
    $e63f08fcb2ac4df1$var$load("8z2kq"),
    $e63f08fcb2ac4df1$var$load("g9CVe"),
    $e63f08fcb2ac4df1$var$load("djHM5"),
    $e63f08fcb2ac4df1$var$load("eJQji"),
    $e63f08fcb2ac4df1$var$load("6wr18"),
    $e63f08fcb2ac4df1$var$load("kjZZD"),
    $e63f08fcb2ac4df1$var$load("3JSgG"),
    $e63f08fcb2ac4df1$var$load("dRpV3"),
    $e63f08fcb2ac4df1$var$load("ffEVr"),
    $e63f08fcb2ac4df1$var$load("dTsOE"),
    $e63f08fcb2ac4df1$var$load("jYUNl"),
    $e63f08fcb2ac4df1$var$load("foy8I"),
    $e63f08fcb2ac4df1$var$load("jY21r"),
    $e63f08fcb2ac4df1$var$load("2vAWg"),
    $e63f08fcb2ac4df1$var$load("7cABH"),
    $e63f08fcb2ac4df1$var$load("9jjvO"),
    $e63f08fcb2ac4df1$var$load("i8eeg"),
    $e63f08fcb2ac4df1$var$load("iFdoJ"),
    $e63f08fcb2ac4df1$var$load("2uVTT"),
    $e63f08fcb2ac4df1$var$load("hhss7"),
    $e63f08fcb2ac4df1$var$load("Wowvf"),
    $e63f08fcb2ac4df1$var$load("4Nzvy"),
    $e63f08fcb2ac4df1$var$load("hJpvQ"),
    $e63f08fcb2ac4df1$var$load("bIPPg"),
    $e63f08fcb2ac4df1$var$load("lnKog"),
    $e63f08fcb2ac4df1$var$load("h3ABO"),
    $e63f08fcb2ac4df1$var$load("kC80R"),
    $e63f08fcb2ac4df1$var$load("7EorR"),
    $e63f08fcb2ac4df1$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("hSmxL", function(module, exports) {

let $d038f77f7c858838$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d038f77f7c858838$var$load("2YffH"),
    $d038f77f7c858838$var$load("lqFMg"),
    $d038f77f7c858838$var$load("duC9l"),
    $d038f77f7c858838$var$load("ci4aH"),
    $d038f77f7c858838$var$load("l1nJ9"),
    $d038f77f7c858838$var$load("eBRUf"),
    $d038f77f7c858838$var$load("9Vh0G"),
    $d038f77f7c858838$var$load("hBIgN"),
    $d038f77f7c858838$var$load("h4Nf7"),
    $d038f77f7c858838$var$load("7f9Fz"),
    $d038f77f7c858838$var$load("8YSo7"),
    $d038f77f7c858838$var$load("eYWAR"),
    $d038f77f7c858838$var$load("8z2kq"),
    $d038f77f7c858838$var$load("g9CVe"),
    $d038f77f7c858838$var$load("djHM5"),
    $d038f77f7c858838$var$load("eJQji"),
    $d038f77f7c858838$var$load("6wr18"),
    $d038f77f7c858838$var$load("kjZZD"),
    $d038f77f7c858838$var$load("3JSgG"),
    $d038f77f7c858838$var$load("dRpV3"),
    $d038f77f7c858838$var$load("ffEVr"),
    $d038f77f7c858838$var$load("dTsOE"),
    $d038f77f7c858838$var$load("jYUNl"),
    $d038f77f7c858838$var$load("foy8I"),
    $d038f77f7c858838$var$load("jY21r"),
    $d038f77f7c858838$var$load("2vAWg"),
    $d038f77f7c858838$var$load("7cABH"),
    $d038f77f7c858838$var$load("9jjvO"),
    $d038f77f7c858838$var$load("i8eeg"),
    $d038f77f7c858838$var$load("iFdoJ"),
    $d038f77f7c858838$var$load("2uVTT"),
    $d038f77f7c858838$var$load("hhss7"),
    $d038f77f7c858838$var$load("Wowvf"),
    $d038f77f7c858838$var$load("4Nzvy"),
    $d038f77f7c858838$var$load("hJpvQ"),
    $d038f77f7c858838$var$load("bIPPg"),
    $d038f77f7c858838$var$load("lnKog"),
    $d038f77f7c858838$var$load("h3ABO"),
    $d038f77f7c858838$var$load("kC80R"),
    $d038f77f7c858838$var$load("7EorR"),
    $d038f77f7c858838$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("bLUyo", function(module, exports) {

let $891ff3e3c53bd3ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $891ff3e3c53bd3ce$var$load("eYWAR"),
    $891ff3e3c53bd3ce$var$load("8z2kq"),
    $891ff3e3c53bd3ce$var$load("2YffH"),
    $891ff3e3c53bd3ce$var$load("lqFMg"),
    $891ff3e3c53bd3ce$var$load("duC9l"),
    $891ff3e3c53bd3ce$var$load("ci4aH"),
    $891ff3e3c53bd3ce$var$load("hJpvQ"),
    $891ff3e3c53bd3ce$var$load("l1nJ9"),
    $891ff3e3c53bd3ce$var$load("eBRUf"),
    $891ff3e3c53bd3ce$var$load("9Vh0G"),
    $891ff3e3c53bd3ce$var$load("hBIgN"),
    $891ff3e3c53bd3ce$var$load("h4Nf7"),
    $891ff3e3c53bd3ce$var$load("7f9Fz"),
    $891ff3e3c53bd3ce$var$load("8YSo7"),
    $891ff3e3c53bd3ce$var$load("g9CVe"),
    $891ff3e3c53bd3ce$var$load("djHM5"),
    $891ff3e3c53bd3ce$var$load("eJQji"),
    $891ff3e3c53bd3ce$var$load("6wr18"),
    $891ff3e3c53bd3ce$var$load("kjZZD"),
    $891ff3e3c53bd3ce$var$load("3JSgG"),
    $891ff3e3c53bd3ce$var$load("dRpV3"),
    $891ff3e3c53bd3ce$var$load("ffEVr"),
    $891ff3e3c53bd3ce$var$load("dTsOE"),
    $891ff3e3c53bd3ce$var$load("jYUNl"),
    $891ff3e3c53bd3ce$var$load("foy8I"),
    $891ff3e3c53bd3ce$var$load("jY21r"),
    $891ff3e3c53bd3ce$var$load("2vAWg"),
    $891ff3e3c53bd3ce$var$load("7cABH"),
    $891ff3e3c53bd3ce$var$load("9jjvO"),
    $891ff3e3c53bd3ce$var$load("i8eeg"),
    $891ff3e3c53bd3ce$var$load("iFdoJ"),
    $891ff3e3c53bd3ce$var$load("bIPPg"),
    $891ff3e3c53bd3ce$var$load("2uVTT"),
    $891ff3e3c53bd3ce$var$load("hhss7"),
    $891ff3e3c53bd3ce$var$load("Wowvf"),
    $891ff3e3c53bd3ce$var$load("4Nzvy"),
    $891ff3e3c53bd3ce$var$load("h3ABO"),
    $891ff3e3c53bd3ce$var$load("kC80R"),
    $891ff3e3c53bd3ce$var$load("7EorR"),
    $891ff3e3c53bd3ce$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("chnoM", function(module, exports) {

let $8f093912450c14ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8f093912450c14ed$var$load("eYWAR"),
    $8f093912450c14ed$var$load("8z2kq"),
    $8f093912450c14ed$var$load("2YffH"),
    $8f093912450c14ed$var$load("lqFMg"),
    $8f093912450c14ed$var$load("duC9l"),
    $8f093912450c14ed$var$load("ci4aH"),
    $8f093912450c14ed$var$load("l1nJ9"),
    $8f093912450c14ed$var$load("eBRUf"),
    $8f093912450c14ed$var$load("9Vh0G"),
    $8f093912450c14ed$var$load("hBIgN"),
    $8f093912450c14ed$var$load("h4Nf7"),
    $8f093912450c14ed$var$load("7f9Fz"),
    $8f093912450c14ed$var$load("8YSo7"),
    $8f093912450c14ed$var$load("g9CVe"),
    $8f093912450c14ed$var$load("djHM5"),
    $8f093912450c14ed$var$load("eJQji"),
    $8f093912450c14ed$var$load("6wr18"),
    $8f093912450c14ed$var$load("kjZZD"),
    $8f093912450c14ed$var$load("3JSgG"),
    $8f093912450c14ed$var$load("dRpV3"),
    $8f093912450c14ed$var$load("ffEVr"),
    $8f093912450c14ed$var$load("dTsOE"),
    $8f093912450c14ed$var$load("jYUNl"),
    $8f093912450c14ed$var$load("foy8I"),
    $8f093912450c14ed$var$load("jY21r"),
    $8f093912450c14ed$var$load("2vAWg"),
    $8f093912450c14ed$var$load("7cABH"),
    $8f093912450c14ed$var$load("9jjvO"),
    $8f093912450c14ed$var$load("i8eeg"),
    $8f093912450c14ed$var$load("iFdoJ"),
    $8f093912450c14ed$var$load("2uVTT"),
    $8f093912450c14ed$var$load("hhss7"),
    $8f093912450c14ed$var$load("Wowvf"),
    $8f093912450c14ed$var$load("4Nzvy"),
    $8f093912450c14ed$var$load("hJpvQ"),
    $8f093912450c14ed$var$load("bIPPg"),
    $8f093912450c14ed$var$load("lnKog"),
    $8f093912450c14ed$var$load("h3ABO"),
    $8f093912450c14ed$var$load("kC80R"),
    $8f093912450c14ed$var$load("7EorR"),
    $8f093912450c14ed$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("7uH8A", function(module, exports) {

let $574ccbf2ac23e482$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $574ccbf2ac23e482$var$load("eYWAR"),
    $574ccbf2ac23e482$var$load("8z2kq"),
    $574ccbf2ac23e482$var$load("2YffH"),
    $574ccbf2ac23e482$var$load("lqFMg"),
    $574ccbf2ac23e482$var$load("duC9l"),
    $574ccbf2ac23e482$var$load("ci4aH"),
    $574ccbf2ac23e482$var$load("l1nJ9"),
    $574ccbf2ac23e482$var$load("eBRUf"),
    $574ccbf2ac23e482$var$load("9Vh0G"),
    $574ccbf2ac23e482$var$load("hBIgN"),
    $574ccbf2ac23e482$var$load("h4Nf7"),
    $574ccbf2ac23e482$var$load("7f9Fz"),
    $574ccbf2ac23e482$var$load("8YSo7"),
    $574ccbf2ac23e482$var$load("g9CVe"),
    $574ccbf2ac23e482$var$load("djHM5"),
    $574ccbf2ac23e482$var$load("eJQji"),
    $574ccbf2ac23e482$var$load("6wr18"),
    $574ccbf2ac23e482$var$load("kjZZD"),
    $574ccbf2ac23e482$var$load("3JSgG"),
    $574ccbf2ac23e482$var$load("dRpV3"),
    $574ccbf2ac23e482$var$load("ffEVr"),
    $574ccbf2ac23e482$var$load("dTsOE"),
    $574ccbf2ac23e482$var$load("jYUNl"),
    $574ccbf2ac23e482$var$load("foy8I"),
    $574ccbf2ac23e482$var$load("jY21r"),
    $574ccbf2ac23e482$var$load("2vAWg"),
    $574ccbf2ac23e482$var$load("7cABH"),
    $574ccbf2ac23e482$var$load("9jjvO"),
    $574ccbf2ac23e482$var$load("i8eeg"),
    $574ccbf2ac23e482$var$load("iFdoJ"),
    $574ccbf2ac23e482$var$load("2uVTT"),
    $574ccbf2ac23e482$var$load("hhss7"),
    $574ccbf2ac23e482$var$load("Wowvf"),
    $574ccbf2ac23e482$var$load("4Nzvy"),
    $574ccbf2ac23e482$var$load("hJpvQ"),
    $574ccbf2ac23e482$var$load("bIPPg"),
    $574ccbf2ac23e482$var$load("lnKog"),
    $574ccbf2ac23e482$var$load("h3ABO"),
    $574ccbf2ac23e482$var$load("kC80R"),
    $574ccbf2ac23e482$var$load("7EorR"),
    $574ccbf2ac23e482$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lk93G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lk93G", function(module, exports) {

let $f8627e0aeed3fccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8627e0aeed3fccf$var$load("hJpvQ"),
    $f8627e0aeed3fccf$var$load("bIPPg"),
    $f8627e0aeed3fccf$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $h82at.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $1cfRh.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.67e0dad2.js.map
